import React from "react";
import { Doughnut } from "react-chartjs-2";

export default function CustomChart({
  type,
  earlyTap,
  lateTap,
  omission,
  commission,
  quickTap,
  label1,
  label2,
  label3,
}) {
  const options = {
    legend: {
      // display: false,
      position: "right",
    },
    elements: {
      arc: {
        borderWidth: 0,
      },
    },
  };

  const data = {
    maintainAspectRatio: false,
    responsive: false,
    showTooltips: true,
    labels: [`${omission} ${label1}`, `${commission} ${label2}`],
    datasets: [
      {
        data: [omission, commission],
        backgroundColor: [
          "#D32976",
          "#FFC700",
          //  "#2B72FE"
        ],

        // hoverBackgroundColor: chartColors,
      },
    ],
  };

  const CRSRData = {
    showTooltips: true,
    maintainAspectRatio: false,
    responsive: false,
    labels: [`${earlyTap} ${label1}`, `${lateTap} ${label2}`],
    datasets: [
      {
        data: [earlyTap, lateTap],
        backgroundColor: [
          "#D32976",
          "#FFC700",

          // "#2B72FE"
        ],
        // hoverBackgroundColor: chartColors,
      },
    ],
  };

  return (
    <Doughnut data={type === "crsr" ? CRSRData : data} options={options} />
  );
}
